import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { userIsLoggedIn } from "../utils/UserAuth";

export const ProtectedRoute = () => {
	const location = useLocation();
	const isLoggedIn = userIsLoggedIn();

	return isLoggedIn ? <Outlet /> : <Navigate to='/login' state={{ from: location }} />;
};

export default ProtectedRoute;
